import React, {Component} from 'react';
import { Link, withRouter } from 'react-router-dom';

class Bottom extends Component {
	constructor(props){
		super(props);
		this.state = {
			search: this.props.match.params.search ? this.props.match.params.search : ``
		}
	}

	handleChange(e) {

		const target = e.target;
		const value = target.type === 'checkbox' ? target.checked : target.value;
		const name = target.name;

		this.setState({
			[name]: value
		},()=>console.log(this.state.search))
	}

	handleSubmit(e){
		e.preventDefault();

		let s = this.state.search ? this.state.search : "All Contracts";

		console.log("Looking: ",s);

		this.props.history.push("/search/"+s.replace(/\s+/g, '-').toLowerCase());

	}

	render(){
		return (
			<div className="bottom container-fluid">
				<div className="container p-0">
					
					<div className="text-center">
						<div className="logo m-auto">
							<h1>Contracts<span>.ph</span></h1>
							<span className="beta">beta</span>
						</div>
					</div>

					{/* Banner form */}
					<form className="header-form form-inline my-4 mx-auto" onSubmit={this.handleSubmit.bind(this)}>
						<div className="input-group mx-auto">
							<input className="form-control form-control-lg" type="search" name="search" placeholder="Search" aria-label="Search" onChange={this.handleChange.bind(this)} />
							<span className="input-group-btn">
								<button className="btn my-2 my-sm-0 default h-100" type="submit">
									<i className="fa fa-search" aria-hidden="true"></i>
								</button>
							</span>
						</div>
					</form>

					{/* Bottom nav */}
					<div className="bottom-nav">
						<ul>
							<li><Link to="/">Home</Link></li>
							<li><Link to="/about-us">About Us</Link></li>
							<li><Link to="/contracts/free-contracts">FREE Contracts</Link></li>
							<li><Link to="/contracts/business">Business</Link></li>
							<li><Link to="/contracts/real-estate">Real Estate</Link></li>
							<li><Link to="/contracts">All Contracts</Link></li>
							<li><Link to="/help">Help</Link></li>
						</ul>
					</div>

					<div className="d-flex align-middle text-center bottom-address justify-content-center my-2">
						<i className="fa fa-map-marker fa-2x" aria-hidden="true"></i>
						<span className="ml-2">Citystate Centre Building 709 Shaw Blvd. Pasig City</span>
					</div>
					<div className="d-flex align-middle text-center bottom-address justify-content-center my-2">
						<i className="fa fa-envelope fa-2x" aria-hidden="true"></i>
						<span className="ml-2"><a href="mailto:support@contracts.ph">support@contracts.ph</a></span>
					</div>

				</div>
			</div>
		);
	}
	
}

export default withRouter(Bottom);


// WEBPACK FOOTER //
// ./src/view/Bottom.js